module.exports = "<div class=\"game-view game-view__questionnaire\">\n\n  <div>\n    <div class=\"questionnaire-title\" data-localize=\"questionnaire.title\"></div>\n    <div class=\"questionnaire-subtitle\" data-localize=\"questionnaire.subtitle\"></div>\n  </div>\n\n  <div id=\"questionnaire__container\">\n\n  </div>\n\n  <div style=\"display: flex; justify-content: flex-end; margin: 4rem 0;\">\n    <button class=\"btn btn-primary btn-lg submit-questionnaire-btn\" data-localize=\"questionnaire.submit\"></button>\n  </div>\n\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/views/partials/game/questionnaire.html
// module id = 807
// module chunks = 2